import { Col, Row } from 'antd';
import { ReactComponent as DotIcon } from '../../../assets/icons/dot.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/right-arrow.svg';
import SvgConverter from '../Common/SvgConverter';

const HorizontalBar = ({ size = 10, dotIcon = true, rightArrow = true }) => {
  return (
    <Row className="horizontal-bar-container" align="middle">
      {dotIcon === true && (
        <Col className={`icon-container lh-${size}`} style={{ height: size }}>
          <SvgConverter Icon={DotIcon} color="distanceColor" width={size} height={size} />
        </Col>
      )}
      <Col className="flex-1" style={{ height: 1 }}>
        <div className="line" />
      </Col>
      {rightArrow === true && (
        <Col className={`icon-container lh-${size}`} style={{ height: size }}>
          <SvgConverter Icon={ArrowRight} color={''} width={size} height={size} />
        </Col>
      )}
    </Row>
  );
};

export default HorizontalBar;
